exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".support-card[data-v-43044863]{border-right:1px solid #000;padding:0 10px 0 0}@media (max-width:768px){.support-card[data-v-43044863]{border:none}}.support-card[data-v-43044863]:last-child{border-right:none}.support-child-container[data-v-43044863]{bottom:50px}", ""]);

// exports
